import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './delete-user-trigger.scss';

applyTranslations(require('./delete-user-trigger.i18n.json'));

interface Props {
  onClick: () => void
}

const MSG_KEY = 'delete_user_trigger';

const DeleteUserTrigger: React.FC<Props> = ({
  onClick
}): JSX.Element => (
  <div
    className="delete-user-trigger"
    onClick={onClick}
  >
    <div className="delete-user-trigger__icon">
      <SVGDynamicIcon
        name="trash-custom-fg"
        width={12}
        height={14}
        customColor="red"
      />
    </div>
    <div className="delete-user-trigger__text">
      {__t(`${MSG_KEY}.text`)}
    </div>
  </div>
);

export default DeleteUserTrigger;
